var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardDoubleArrowDown = function SvgKeyboardDoubleArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "keyboard_double_arrow_down_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#keyboard_double_arrow_down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 16.175 3.9-3.875a.98.98 0 0 1 .687-.288.93.93 0 0 1 .713.288.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-4.6 4.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-4.6-4.6a.98.98 0 0 1-.288-.687.93.93 0 0 1 .288-.713.95.95 0 0 1 .7-.275q.425 0 .7.275zm0-6L15.9 6.3a.98.98 0 0 1 .687-.288.93.93 0 0 1 .713.288.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-4.6 4.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063q-.2 0-.375-.062a.9.9 0 0 1-.325-.213L6.7 7.7a.98.98 0 0 1-.288-.688A.93.93 0 0 1 6.7 6.3a.95.95 0 0 1 .7-.275q.425 0 .7.275z"
  }))));
};
export default SvgKeyboardDoubleArrowDown;